import { PropType, defineComponent, h } from 'vue';
import { ID } from '@phi/newtype';
import { PartstudioElement, AnyBody } from '@phi/onshape';
import { vif1 } from '@phi/util/vuetils';
import { Option } from '@vaaas/fpts/option';
import OnshapeElementExplorer from '../OnshapeElementExplorer';
import OnshapeDocumentExplorer from '../OnshapeDocumentExplorer';
import OnshapePartExplorer from '../OnshapePartExplorer';

export default defineComponent({
    props: {
        document: {
            required: true,
            type: null as any as PropType<Option<ID<'document'>>>,
        },

        workspace: {
            required: true,
            type: null as any as PropType<Option<ID<'workspace'>>>,
        },

        element: {
            required: true,
            type: null as any as PropType<Option<PartstudioElement>>,
        },

        part: {
            required: true,
            type: null as any as PropType<Option<AnyBody>>,
        },

        can_select_document: {
            required: false,
            type: Boolean,
            default: true,
        },

        placeholder: {
            required: false,
            type: String,
            default: 'Search by part name'
        },
    },

    computed: {
        has_selected_document(): boolean {
            return Boolean(this.document && this.workspace);
        }
    },

    emits: {
        'update:workspace': (x: Option<ID<'workspace'>>) => true,
        'update:document': (x: Option<ID<'document'>>) => true,
        'update:element': (x: Option<PartstudioElement>) => true,
        'update:part': (x: Option<AnyBody>) => true,
    },

    render() {
        return h('div', {
            class: {
                'select-document-element': true,
                'selecting-document': !this.has_selected_document,
                'selecting-element': this.has_selected_document,
            },
        }, [
            vif1(
                this.has_selected_document
                && this.element !== undefined
            )(() => h(OnshapePartExplorer, {
                document: this.document!,
                workspace: this.workspace!,
                element: this.element!,
                part: this.part,
                'onUpdate:part': x => this.$emit('update:part', x),
                'onBack': () => {
                    this.$emit('update:element', undefined);
                    this.$emit('update:part', undefined);
                },
            })),

            vif1(
                this.has_selected_document
                && this.element === undefined
            )(() => h(OnshapeElementExplorer, {
                document: this.document,
                workspace: this.workspace,
                element: this.element,
                'onUpdate:element': x => this.$emit('update:element', x as Option<PartstudioElement>),
                'onBack': () => {
                    this.$emit('update:document', undefined);
                    this.$emit('update:workspace', undefined);
                },
                elementFilter: x => x.elementType === 'PARTSTUDIO',
                back: this.can_select_document,
                sub_heading: false,
                placeholder: this.placeholder,
                hidden_toggle: false,
            })),

            vif1(
                !this.has_selected_document
                && this.can_select_document
            )(() => h(OnshapeDocumentExplorer, {
                document: this.document,
                workspace: this.workspace,
                'onUpdate:document': x => this.$emit('update:document', x),
                'onUpdate:workspace': x => this.$emit('update:workspace', x),
            })),
        ]);
    },
});
